export class Suitability {

    constructor() {}

    Knowledge: number;

    // Suitability
    PoupancaPrev: boolean;
    poupanca: boolean;
    poupancaValue: number;

    FixaPrev: boolean;
    fixa: boolean;
    fixaValue: number;

    FundosPrev: boolean;
    fundos: boolean;
    fundosValue: number;

    StocksPrev: boolean;
    stocks: boolean;
    stocksValue: number;

    DerivativosPrev: boolean;
    derivativos: boolean;
    derivativosValue: number;
}